import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateWarehouseVehicleSetupActions as Actions,
  CreateWarehouseVehicleSetupRequestAction as RequestAction,
} from 'store/ducks/warehouseVehicleSetups';

export function* createWarehouseVehicleSetupRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `warehouse-vehicle-setups`, postData);
    onSuccess && onSuccess();
    notify('success', 'Setup de veículo vinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
